import { LaravelResponse, PagedMultiSelectFieldProps, TextField } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TenantIndexResource } from "../../../shared/types/tenant";
import { UserTenantMultiSelect } from "../../../shared/ui/UserTenantSelect";
import { CompanyTenantPivotValue } from "../shared/types";
import { CompanyDrawerFormTenantFields } from "./CompanyDrawerFormTenantFields";
import { CompanySelectField } from "./CompanySelectField";
import { emptyCompanyPivotValue } from "./create/CreateCompanyDrawer";

interface Props {
	getLabel?: PagedMultiSelectFieldProps<TenantIndexResource, LaravelResponse<TenantIndexResource>>["getLabel"];
}

export const CompanyDrawerFormFields: FC<Props> = ({ getLabel }) => {
	const { t } = useTranslation();
	const [{ value: pivotValues }, , { setValue }] = useField("pivotValues");

	return (
		<>
			<TextField name="name" label={t("Name")} required={true} />
			<CompanySelectField name="parent" label={t("Parent company")} />
			<UserTenantMultiSelect
				name="tenants"
				label={t("Tenants")}
				getLabel={getLabel}
				onChange={(e) => {
					const values: Record<string, CompanyTenantPivotValue> = {};
					e.target.value.forEach(({ id }) => (values[id] = pivotValues[id] ?? emptyCompanyPivotValue));
					setValue(values);
				}}
				required
			/>
			<CompanyDrawerFormTenantFields />
		</>
	);
};
